import React from "react";
import {AssistantSetUp} from "./components/AssistantSetUp/AssistantSetUp";
import {FullBotUi} from "../../../../../api/generated";
import {AssistantInformation} from "./components/AssistantInformation/AssistantInformation";
import {UrlProcessor} from "./components/UrlProcessor/UrlProcessor";
import styles from "./AssistantInformationTab.module.css"

interface AssistantInformationTabProps {
    bot: FullBotUi
}

export const AssistantInformationTab: React.FC<AssistantInformationTabProps> = ({bot}) => {
    return <div className={styles.wrapper}>
        <AssistantInformation bot={bot}/>
        <UrlProcessor bot={bot}/>
        <AssistantSetUp bot={bot}/>
    </div>
}
